import { lazy, Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import { urlSAC } from "./lib/zentria";

/**
 * La web ya no cotiza: eso vive en el portal SAC del cliente. La ruta vieja
 * se conserva porque puede estar enlazada desde fuera, y lleva alli.
 */
function IrAlPortalSAC() {
  if (typeof window !== "undefined") window.location.replace(urlSAC());
  return null;
}

import Home from "./pages/Home.jsx";
import Catalogo from "./pages/Catalogo.jsx";
import ProductoDetalle from "./pages/ProductoDetalle.jsx";
import Servicios from "./pages/Servicios.jsx";
import Nosotros from "./pages/Nosotros.jsx";
import Contacto from "./pages/Contacto.jsx";
import Carrito from "./pages/Carrito.jsx";
import Checkout from "./pages/Checkout.jsx";
import Confirmacion from "./pages/Confirmacion.jsx";
import Login from "./pages/Login.jsx";
import NoEncontrado from "./pages/NoEncontrado.jsx";

import CuentaGuard from "./components/cuenta/CuentaGuard.jsx";
import MiCuenta from "./pages/cuenta/MiCuenta.jsx";

import AdminGuard from "./components/admin/AdminGuard.jsx";

/**
 * El panel solo lo abre el equipo de Aceros Lima, asi que su codigo se carga
 * bajo demanda y no pesa en la primera visita de un cliente.
 */
const AdminLayout = lazy(() => import("./pages/admin/AdminLayout.jsx"));
const Dashboard = lazy(() => import("./pages/admin/Dashboard.jsx"));
const ProductosAdmin = lazy(() => import("./pages/admin/ProductosAdmin.jsx"));
const CategoriasAdmin = lazy(() => import("./pages/admin/CategoriasAdmin.jsx"));
const CotizacionesAdmin = lazy(() => import("./pages/admin/CotizacionesAdmin.jsx"));
const PedidosAdmin = lazy(() => import("./pages/admin/PedidosAdmin.jsx"));
const MensajesAdmin = lazy(() => import("./pages/admin/MensajesAdmin.jsx"));

function Cargando() {
  return (
    <div style={{ padding: "3rem 1.5rem" }}>
      <p className="mono">Cargando...</p>
    </div>
  );
}

function conSuspense(Componente) {
  return (
    <Suspense fallback={<Cargando />}>
      <Componente />
    </Suspense>
  );
}

export const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <App />,
      errorElement: <NoEncontrado />,
      children: [
        { index: true, element: <Home /> },
        { path: "productos", element: <Catalogo /> },
        { path: "productos/:id", element: <ProductoDetalle /> },
        { path: "servicios", element: <Servicios /> },
        { path: "nosotros", element: <Nosotros /> },
        { path: "contacto", element: <Contacto /> },
        // El cotizador propio se retiro: las cotizaciones se atienden en el
        // portal SAC del cliente. La ruta se conserva redirigiendo, porque
        // puede estar enlazada desde fuera.
        { path: "cotizador", element: <IrAlPortalSAC /> },
        { path: "carrito", element: <Carrito /> },
        { path: "checkout", element: <Checkout /> },
        { path: "confirmacion/:codigo", element: <Confirmacion /> },
        { path: "login", element: <Login /> },
        {
          path: "cuenta",
          element: <CuentaGuard />,
          children: [{ index: true, element: <MiCuenta /> }],
        },
        { path: "*", element: <NoEncontrado /> },
      ],
    },
    {
      path: "/admin",
      element: <AdminGuard />,
      children: [
        {
          element: conSuspense(AdminLayout),
          children: [
            { index: true, element: conSuspense(Dashboard) },
            { path: "productos", element: conSuspense(ProductosAdmin) },
            { path: "categorias", element: conSuspense(CategoriasAdmin) },
            { path: "cotizaciones", element: conSuspense(CotizacionesAdmin) },
            { path: "pedidos", element: conSuspense(PedidosAdmin) },
            { path: "mensajes", element: conSuspense(MensajesAdmin) },
          ],
        },
      ],
    },
  ],
  {
    // Adopta desde ya el comportamiento de React Router 7 y silencia sus avisos.
    future: {
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionErrorRevalidation: true,
    },
  }
);
